.topNav {
  z-index: var(--topNavZ);
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: var(--primitives-colors-neutral-980);
  top: 0;
  color: var(--primitives-colors-neutral-0);
  margin: auto;
  align-items: center;
  padding: 0 16px;
  max-height: var(--header-height);
  min-height: var(--header-height);
  position: fixed;
  left: 0;
  transition: top .5s;

  /* mobile_fullscreen experiment: no header while in fullscreen */
  .mobileFullscreen & {
    display: none;
  }

  .mainLogo {
    margin-left: 8px;

    .phone &,
    .tablet & {
      margin-right: 5px;
      margin-left: 0;

      img {
        margin-left: -7px;
        width: 70px;
        height: 100%;
      }
    }
  }

  &.topNavV2 {
    border-bottom: none;
    background-color: transparent;

    .scrolled & {
      top: 0!important;
    }

    .burgerMenu {
      left: 0;
      right: inherit;
    }
  }

  &.activeSearch,
  &.activeProfileMenu {
    &.hiddenV2Header {
      display: flex;
    }
  }

  &.activeSearch:not(.topNavV2) {
    .phone &,
    .tablet & {
      border-bottom: none;
      height: 100%;
      max-height: 104px;
      align-items: center;
    }
  }

  &.activeProfileMenu {
    background-color: var(--primitives-colors-neutral-980);
  }

  &.activeBurgerMenu {
    &.hiddenV2Header {
      display: flex;

      .mainHeaderV2 {
        display: none;
      }
    }
  }

  .scrolled & {
    top: -100px;
  }

  &.hiddenV2Header {
    display: none;
  }
}
